module.exports = __webpack_public_path__ + "media/images/emblems/Grindelwald-coat_of_arms-c18b5d17878bdcd7f4f08928159f0dc3.svg";